import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';

import CheckIcon from 'images/icons/check.svg';

import { SolutionsDetail } from 'styles/solutions-detail';
import SolutionSteps from '../../components/SolutionSteps/SolutionSteps';

const SolutionCVAPage = ({ path }) => (
  <>
    <Meta
      title="Chatbots & Voice Assistants | ATC Digital Business Solutions"
      description="Chatbots are an integral part of an enterprise’s digital transformation. Its integration into all areas of your business facilitates onward innovation and growth."
    />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="solutions/chatbots-va-banner.jpg"
          title="Chatbots and Voice Assistants. Streamline process."
          className="darken-image"
          style={{ paddingBottom: 100 }}
        >
          <p
            className="white-txt"
            style={{
              fontSize: 18,
              letterSpacing: 0.2,
              lineHeight: '28px',
            }}
          >
            Chatbots are an integral part of an enterprise’s digital
            transformation. Its integration into all areas of your business
            facilitates onward innovation and growth.
          </p>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Learn how to get started</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>

        <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">
                  Redefining work in today’s modern enterprise.
                </h2>
                <p className="white-txt">
                  Chatbots are text and voice enabled with AI inclusion to
                  handle your organization’s most complex tasks. Inputs
                  including Alexa, Cortana, and Watson, allow a seamless
                  automated experience for your employees and customers.
                  Task-oriented chatbots easily replicate, automate, and perform
                  workflow sequences across any workplace department. Automation
                  increases speed, efficiency, and accuracy, expanding company
                  output and productivity while simultaneously cutting costs.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps
          id="chatbotsVoiceAssistant"
          flyText="Chatbots and Voice Assistants"
          flyBoxImage="solutions/chatbot-box.jpg"
        />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  Enhance Your Customer Experience, <br />Increase Your Bottom Line
                </h2>
                <p>
                  Once trained and deployed, AI-powered chatbots can converse effectively with your customers,
                  helping them with their queries, walking them through pre-defined processes,
                  or filling out forms and aiding purchases. Chatbots work round the clock,
                  thus reducing the need to have a customer support team working 24/7.
                  Chatbots allow your internal teams and your customers to get the information they want,
                  anytime, anywhere. Well trained and designed chatbots can help your business save thousands of dollars
                  usually spent on customer support services.
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    Outcomes
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>40%</h3>
                        <p>Increase in Employee Productivity.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>24%</h3>
                        <p>Increase in Digital Engagement.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>30-50%</h3>
                        <p>Improve Customer Satisfaction.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>30-50%</h3>
                        <p>Reduce Customer Support Cost.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionCVAPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionCVAPage;
